import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactSimpleModal from 'shared/design-system/components/TrueImpactSimpleModal';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

export const SupportText: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <div className={className}>
      If you run into any issues or have questions, please don't hesitate to
      reach out to us at{' '}
      <a href="mailto:support@trueimpact.com">support@trueimpact.com</a>.
    </div>
  );
};

let openStateInSession = true;

const StyledDiv = styled.div`
  max-width: 600px;
  padding: ${SPACERS.medium};
`;

const InfoModal: React.FC = () => {
  const [open, setOpen] = useState<boolean>(openStateInSession);

  const handleClose = useCallback(() => {
    setOpen(false);
    openStateInSession = false;
  }, [setOpen]);

  if (!open) return null;

  return (
    <TrueImpactSimpleModal
      open={open}
      contentStyle={{
        borderRadius: 4,
      }}
      footerStyle={{
        borderRadius: 4,
      }}
      onClose={handleClose}
      next={{
        text: 'Ok, I understand',
        onClick: handleClose,
      }}
    >
      <StyledDiv>
        <TrueImpactText variant="heading">
          Congratulations! You just built your impact model!
        </TrueImpactText>
        <TrueImpactText>
          Need to make changes? No problem, From this point forward, you can
          edit any aspect of your impact model directly from this page without
          having to navigate back through the impact model builder and details
          sections.
          <br />
          <br />
          <SupportText />
        </TrueImpactText>
      </StyledDiv>
    </TrueImpactSimpleModal>
  );
};

export default InfoModal;
